<span class="version">{{'HEADER.SchedulersPortal' | translate}}</span>
